import API from '@/config/api';
import $http from '@/utils/fetch';
import store from '@/store';

import Cookie from 'js-cookie';
import { getAppAuth } from '@/utils/tool';

const ua = navigator.userAgent;

const isWechatBroswer = navigator.userAgent.toLowerCase().includes('micromessenger');
const OPEN_WECHAT_ADDRESS = 'https://open-wx.meishakeji.com/target.html';
const APPID = 'wx6ff5215676b7b603';
const WECHAT_AUTH = 'https://open.weixin.qq.com/connect/oauth2/authorize';
/* 微信获取code,不同系统需修改appid和授权地址 */
const getWechatCodeUrl = () => {
  const appId = APPID;
  let localUrl = window.location.href.split('#')[0];
  let target = `${OPEN_WECHAT_ADDRESS}?localUrl=${localUrl}`;
  let REDIRECT_URI = encodeURI(target);
  /* eslint-disable max-len */
  return `${WECHAT_AUTH}?appid=${appId}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=snsapi_userinfo&state=fromHere&component_appid=wxd9e96d45d68ffc75#wechat_redirect`;
};

export const getFormSetting = async (id) => {
  let formSetting = store.state.formSetting;
  if (!formSetting) {
    const api = API.GET_FORM_SETTING;
    const data = {
      formId: id
    };
    formSetting = await $http.post(api, data)
      .then(res => {
        return res.data;
      })
      .catch(err => {
        throw err;
      });
    store.commit('SET_FORM_SETTING', formSetting);
  }

  return formSetting;
};

export const auth = async (to, from, next) => {
  const { fromAdmin, anonymous, id, code, fromStudentList, ref } = to.query;
  if (fromAdmin === '1' || fromAdmin === '2') { // 1: 表示管理端预览模版 2: 表示管理端预览答卷 两者都不需要登录，且获取不到表单设置
    next();
    return;
  }
  if (!id) {
    next();
    return;
  }
  const { anyOne, sysUser } = await getFormSetting(id); // 先要获取表单的设置，包含表单是否过期等信息
  if (!to.meta.needLogin || anonymous) { // 如果是不需要登录的页面或者匿名表单，直接跳转
    next();
  } else {
    if (anyOne === 0) { // 匿名表单
      next({
        name: to.name,
        query: {
          ...to.query,
          anonymous: 1
        }
      });
    } else if (ref === 'crm') { // 从 crm 跳转过来的
      const auth = Cookie.get('crm-auth');
      if (auth) {
        localStorage.setItem('auth', auth);
        next();
      } else {
        throw Error('cookie not exist');
      }
    } else if (ref === 'sale') { // 从 crm 跳转过来的
      if (/meishakeji/i.test(ua)) { // app 中打开
        getAppAuth(next);
      } else {
        const auth = Cookie.get('crm-auth');
        if (auth) {
          localStorage.setItem('auth', auth);
          next();
        } else {
          throw Error('cookie not exist');
        }
      }
    } else if (ref === 'vschoolH5') {
      const auth = Cookie.get('vschool-auth');
      if (auth) {
        localStorage.setItem('auth', auth);
        next();
      } else {
        throw Error('cookie not exist');
      }
    } else { // 注册用户可以填写
      // 判断是否登录
      const auth = localStorage.getItem('auth');
      if (!auth) {
        if (isWechatBroswer) {
          // 判断是不是从微信授权页回来的，授权回来之后，url后面会带上code
          if (code) {
            const api = API.WE_CHAT_LOGIN;
            const data = {
              code
            };
            const result = await $http.post(api, data)
              .then(res => {
                return res.data;
              })
              .catch(err => {
                return err;
              });
            if (result.code === -1004) { // 没有绑定手机号
              const { id } = to.query;
              next({
                name: 'Login',
                query: {
                  id,
                  userKey: result.data.userKey
                }
              });
            } else { // 已经绑定过手机号
              // auth
              const auth = result.auth;
              auth && localStorage.setItem('auth', auth);
              const { code, state, ...rest } = to.query;
              if (sysUser === 1) {
                next({
                  name: 'Form',
                  query: {
                    ...rest
                  }
                });
              } else {
                next({
                  name: 'SelectStudent',
                  query: {
                    ...rest,
                    fromStudentList: 1
                  }
                });
              }
            }
          } else {
            const weixinUrl = getWechatCodeUrl();
            window.location.replace(weixinUrl);
          }
        } else if ($app.isApp) {
          $app.appCallbackMethod('loginApp', {}, {
            register: true,
            resIsObject: true
          }).then(res => {
            // console.log('loginApp res', res);
            if (res && res.auth) {
              localStorage.setItem('auth', res.auth);
              if (sysUser === 1) {
                next();
              } else {
                next({
                  name: 'SelectStudent',
                  replace: true,
                  query: {
                    ...to.query,
                    fromStudentList: 1
                  }
                });
              }
            } else throw new Error('返回值中auth为空');
          }).catch(err => {
            console.error('login error:', err.message, err);
            next({
              name: 'Login',
              replace: true,
              query: {
                id
              }
            });
          });
        } else {
          next({
            name: 'Login',
            query: {
              id
            }
          });
        }
      } else {
        // 已登录，如果是学员登录，则去选择学员
        if (sysUser === 2 && to.name === 'Form' && !fromStudentList) {
          next({
            name: 'SelectStudent',
            query: {
              id,
              fromStudentList: 1
            }
          });
        } else {
          next();
        }
      }
    }
  }
};
